var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSeaFood = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25 18.3333C24.08 18.3333 23.3333 19.0783 23.3333 20V25C23.3333 27.17 21.935 29.0033 20 29.6933V20.8333C20 19.9116 19.2533 19.1666 18.3333 19.1666C17.4133 19.1666 16.6667 19.9116 16.6667 20.8333V29.6933C14.7317 29.0033 13.3333 27.17 13.3333 25V20C13.3333 19.0783 12.5867 18.3333 11.6667 18.3333C10.7467 18.3333 10 19.0783 10 20V25C10 28.4083 12.0617 31.3366 15 32.6266V36.6666H21.6667V32.6266C24.605 31.3366 26.6667 28.4083 26.6667 25V20C26.6667 19.0783 25.92 18.3333 25 18.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M10 9.99998C10.98 6.08165 14.5 3.33331 18.5383 3.33331H24.205C25.3833 3.33331 26.19 4.52498 25.7517 5.61831L23.3333 11.6666L10 9.99998Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.3333 11.6667L34.1099 7.04501C34.8616 6.44334 35.9366 7.19168 35.6316 8.10501L35.2649 9.20668C34.0183 12.9467 34.1383 17.0067 35.6016 20.6667C35.9449 21.5267 34.9999 22.3317 34.2066 21.855L28.3333 18.3333V11.6667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 6.66669C10.2849 6.66669 3.33325 10.3984 3.33325 15C3.33325 19.6017 10.2849 23.3334 16.6666 23.3334C23.0483 23.3334 29.9999 19.6017 29.9999 15C29.9999 10.3984 23.0483 6.66669 16.6666 6.66669ZM9.99992 15C9.07992 15 8.33325 14.2534 8.33325 13.3334C8.33325 12.4134 9.07992 11.6667 9.99992 11.6667C10.9199 11.6667 11.6666 12.4134 11.6666 13.3334C11.6666 14.2534 10.9199 15 9.99992 15Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M9.99992 15C10.9204 15 11.6666 14.2538 11.6666 13.3334C11.6666 12.4129 10.9204 11.6667 9.99992 11.6667C9.07944 11.6667 8.33325 12.4129 8.33325 13.3334C8.33325 14.2538 9.07944 15 9.99992 15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSeaFood, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sea-food.28a699cb.svg";
export { ForwardRef as ReactComponent };